import Vue from "vue";
import router from "@/router";
import store from "@/store";
import axios from "axios";

axios.defaults.withCredentials = true;

Vue.mixin({
  data() {
    return {
      filter: "",
      asc: -1
    };
  },
  methods: {
    ChangeFilter(newFilter) {
      if (newFilter != this.filter) {
        this.filter = newFilter;
        this.asc = -1;
      } else {
        if (this.asc != 0) {
          this.asc = 0;
        } else {
          this.asc = -1;
        }
      }
    }
  }
});

export default {
  vpsDomain: "deployify.net",
  notificationIntervalId: null,
  url: !window.location.host.includes("test")
    ? "https://licensing.deployify.io/api/"
    : "http://test.licensing.io:3111/api/",

  shared: {
    updateData: false,
    lastPlayPage: null
  },
  status: {
    message: null,
    show: false,
    saved: false,
    saving: false,
    timeout: 4000
  },

  GetAuthInfo() {
    let user = Vue.ls.get("user");
    let role = Vue.ls.get("role");

    if (user && role) {
      store.state.auth.user = user;
      store.state.auth.role = role;
      store.state.auth.success = true;
    }
  },

  // async Impersonate(userUID) {
  //   if (userUID) {

  //     var res = await this.PostApi('get/user', {
  //       userUID: userUID
  //     });

  //     if (res.length != 0) {

  //       if (this.auth.impersonate == userUID) {
  //         this.auth.impersonate = null;
  //       } else if (!this.auth.impersonate) {
  //         this.auth.impersonate = this.auth.user.uid
  //       }

  //       Vue.ls.set('user', res[0].user);
  //       Vue.ls.set('role', res[0].role);

  //       this.GetAuthInfo(true);

  //       this.ShowStatus("Välkommen " + res[0].user.name + "!", 4000, this.status);
  //     }
  //   }
  // },

  GetSiteSetting(key) {
    return new Promise(resolve => {
      this.PostApi("secure/get/userSiteSetting", {
        key: key
      }).then(res => {
        if (res.data.length > 0 && res.data[0].value) {
          let data = res.data[0].value;

          if (typeof data === "string" && data.startsWith("{")) {
            data = JSON.parse(data);
          } else {
            data = res.data[0].value;
          }
          resolve(data[key]);
        }

        resolve(null);
      });
    });
  },

  Validate(arr) {
    let invalid = arr.find(item => !item.valid);

    if (!invalid) {
      return true;
    } else {
      return false;
    }
  },

  ShowNotification(text, css, timeout) {
    store.state.notification.show = true;
    store.state.notification.css = "is-primary animated fadeIn";
    store.state.notification.text = text;

    if (css) {
      store.state.notification.css = "is-" + css;
    }

    if (timeout) {
      if (this.notificationIntervalId) {
        clearInterval(this.notificationIntervalId);
      }

      store.state.notification.timeout = timeout;

      this.notificationIntervalId = setInterval(() => {
        store.state.notification.timeout =
          store.state.notification.timeout - 1000;
        if (store.state.notification.timeout <= 0) {
          store.state.notification.show = false;
          clearInterval(this.notificationIntervalId);
          this.notificationIntervalId = null;
        }
      }, 1000);
    }
  },

  GetBool(val) {
    if (val) {
      return !!JSON.parse(String(val).toLowerCase());
    }

    return false;
  },

  Filter(items, filter) {
    items = items.filter(item => {
      return this.DoesObjMatch(item, filter);
    });

    return items;
  },

  SetItem(item, items, filter) {
    var index = this.GetIndex(items, filter);
    Vue.set(items, index, item);
    return items;
  },

  RemoveItem(item, items, filter) {
    var index = this.GetIndex(items, filter);
    items.splice(index);
    return items;
  },

  GetIndex(items, filter) {
    for (let [index, item] of items.entries()) {
      if (this.DoesObjMatch(item, filter)) {
        return index;
      }
    }

    return -1;
  },

  CopyItem(item) {
    return JSON.parse(JSON.stringify(item));
  },

  DoesObjMatch(item, filter) {
    item = Object.assign({}, item);

    for (let prop in filter) {
      if (!item[prop] && !filter[prop]) {
        return true;
      } else if (!item[prop] && filter[prop]) {
        return false;
      }

      //console.log(item[prop]);

      if (
        typeof item[prop] !== "string" &&
        Object.getOwnPropertyNames(item[prop]).length != 0
      ) {
        return this.DoesObjMatch(item[prop], filter[prop]);
      } else {
        // console.log(filter[prop]);
        // console.log(item[prop]);

        if (typeof item[prop] === "string") {
          item[prop] = item[prop].toLowerCase();
        }

        if (typeof filter[prop] === "string") {
          filter[prop] = filter[prop].toLowerCase();
        }

        if (typeof filter[prop] === "string" && filter[prop].includes("|")) {
          if (filter[prop].split("|").indexOf(item[prop]) !== -1) {
            return true;
          }

          return false;
        } else {
          return this.CheckFilter(item, filter, prop);
        }
      }
    }
  },
  CheckFilter(item, filter, prop) {
    if (filter[prop][0] == "!") {
      return this.CheckNotStrFilter(item, filter, prop);
    } else {
      return item[prop] === filter[prop] ? true : false;
    }
  },
  CheckNotStrFilter(item, filter, prop) {
    filter[prop] = filter[prop].replace("!", "");
    return item[prop] !== filter[prop] ? true : false;
  },

  GetProp(obj, propStr) {
    if (obj) {
      var arr = propStr.split(".");
      while (arr.length && (obj = obj[arr.shift()]));
      return obj;
    }

    return null;
  },

  DoesItemExist(item, items) {
    for (let currentItem of items) {
      if (currentItem.toLowerCase() == item.toLowerCase()) {
        return currentItem;
      }
    }

    return null;
  },

  Map(items, property) {
    if (items) {
      return items.map(item => {
        return item[property];
      });
    }

    return [];
  },

  paging: {
    GetPageNumbers: items => {
      let numberArray = [];
      let total = items.length;

      if (total != 0) {
        let numbers = total / 10;

        let i;

        for (i = 0; i < numbers; i++) {
          numberArray.push((i + 1).toString());
        }
      } else {
        numberArray.push("1");
      }

      return numberArray;
    },

    GetPageStartIndex: page => {
      page = page - 1;
      let start = page * 10;
      return start;
    }
  },

  async ClearForm(form) {
    for (let input of form.inputs) {
      input.value = null;
    }
  },

  ClearStrings(obj) {
    for (let property in obj) {
      if (
        typeof obj[property] === "string" ||
        obj[property] instanceof String
      ) {
        obj[property] = null;
      } else if (typeof obj[property] === "object") {
        this.ClearStrings(obj[property]);
      }
    }

    return obj;
  },

  RemoveFromArray(items, filter) {
    var index = this.GetIndex(items, filter);
    items.splice(index, 1);
    return items;
  },

  ShowStatus(message, timeout, color) {
    this.ShowNotification(message, color, timeout);
  },

  GoTo(url) {
    router.push({
      path: url
    });
  },

  async Logout(skipApiCall) {
    if (!skipApiCall) {
      try {
        await this.PostApi("logout", {});
      } catch (error) {}
    }

    Vue.ls.clear();

    store.state.auth.success = false;
    store.state.auth.user = {};
    store.state.auth.role = {};

    router.push({
      path: "/signin"
    });
  },

  async PostApi(path, data, skipAuth, onlyData = true) {
    return new Promise(async (resolve, reject) => {
      if (!skipAuth) {
        path = `secure/${path}`;
      }

      try {
        let res = await axios.post(
          this.url + path,
          {
            data: data
          },
          { withCredentials: true }
        );

        if (onlyData) {
          resolve(res.data.data);
        }

        resolve(res);
      } catch (err) {
        console.log(err.response.status, 2);

        if (
          err.response.status === 401 &&
          router.currentRoute.path != "/logout"
        ) {
          this.Logout(true);
        } else if (err.response.status === 403) {
          this.ShowNotification(
            `The request (${path}) was denied`,
            "warning",
            5000
          );
        }

        reject(err);
        //return err;
      }
    });
  }
};
